import React from "react";
import styles from "./Garden.module.css";
import classNames from "classnames";
import CrossCountryGrid from "./cross-country-grid/CrossCountryGrid";
import DronePoetCove from "./island/DronePoetCove";

export default function Garden(props) {
  console.log("Garden -> project", props);

  const { routes } = props;

  const pageClassNames = classNames("hfeed", "site");

  const renderGarden = () => {
    if (routes.length === 4) {
      const { project: routeProject } = routes[3];
      switch (routeProject) {
        case "cross-country-grid":
          return <CrossCountryGrid />;
        default:
          return null;
      }
    }

    return null;
  };

  return (
    <div id="garden" className={pageClassNames}>
      <div id="content" className={styles.site_content} role="main">
        <DronePoetCove />
        {renderGarden()}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/gardens/Garden.js